import { NgModule } from '@angular/core';

import { MenuItems } from './menu-items/menu-items';
import { AccordionAnchorDirective, AccordionLinkDirective, AccordionDirective } from './accordion';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatMenuModule } from '@angular/material/menu';
import { MatInputModule } from '@angular/material/input';
import { MatRadioModule } from '@angular/material/radio';
import { MatButtonModule } from '@angular/material/button';
// import { MatButtonModule, MatRadioModule, MatInputModule, MatMenuModule, MatCheckboxModule } from '@angular/material';
import { MatCardModule } from '@angular/material/card';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatListModule } from '@angular/material/list';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatDividerModule } from '@angular/material/divider';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatSortModule } from '@angular/material/sort';
import { MatDialogModule } from '@angular/material/dialog';
import { MatSelectModule } from '@angular/material/select';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatTableModule } from '@angular/material/table';
import { NgxMatSelectSearchModule } from 'ngx-mat-select-search';

import { MatSliderModule } from '@angular/material/slider';
import { MatBadgeModule } from '@angular/material/badge';
import { MatNativeDateModule } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatChipsModule } from '@angular/material/chips';
import { MatTreeModule } from '@angular/material/tree';
import { MatTabsModule } from '@angular/material/tabs';
import { MatExpansionModule } from '@angular/material/expansion';
// import { ToastrModule } from 'ngx-toastr';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AuthGuard } from './guard/auth.guard';
import { CommonModule } from '@angular/common';
import { MatGridListModule } from '@angular/material/grid-list';
import { MatFabMenuModule } from '@angular-material-extensions/fab-menu';
import { EcoFabSpeedDialModule } from '@ecodev/fab-speed-dial';
import { MatTooltipModule } from '@angular/material/tooltip';
import { DebounceClickDirective } from '../directives/debounce-click.directive';
import { MenuItemsGuichet } from './menu-items/menu-item-guichet';
// import { MAT_MOMENT_DATE_FORMATS, MomentDateAdapter, MAT_MOMENT_DATE_ADAPTER_OPTIONS } from '@angular/material-moment-adapter';
import { MenuItemsRetrait } from './menu-items/menu-item-retrait';
import { MenuItemsEnvoi } from './menu-items/menu-item-envoi';
import { MenuItemsChef } from './menu-items/menu-item-chef';
import { MenuItemsAccounting } from './menu-items/menu-item-accounting';
import { MenuItemsFiscalite } from './menu-items/menu-item-fiscalite';
import { MenuItemsChefCourrier } from './menu-items/menu-item-chefcourrier';
import { MenuItemsDispatching } from './menu-items/menu-item-dispatching';
import { ReservationComponent } from 'src/app/module/reservation/reservation/reservation.component';
import { TranslateModule } from '@ngx-translate/core';
import { ReservationmodalComponent } from '../../module/reservation/reservationmodal/reservationmodal.component';
import { FlexLayoutModule } from '@angular/flex-layout';
import { TableConfigComponent } from './components/table-config/table-config.component';
import { RoleGuard } from './guard/role-guard';
import { SessionGuard } from './guard/session-guard';
import { SatPopoverModule } from '@ncstate/sat-popover';
import { UserNamePipe } from './pipes/user-name.pipe';
// import {ConnectionServiceModule} from 'ng-connection-service';
// import {ConnectionServiceModule} from 'ngx-connection-service';


import { NativeDateAdapter, DateAdapter, MAT_DATE_FORMATS } from '@angular/material/core';

export const APP_DATE_FORMATS = {
  parse: {
    dateInput: 'DD/MM/YYYY',
  },
  display: {
    dateInput: 'DD/MM/YYYY',
    monthYearLabel: 'MMM YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'MMMM YYYY',
  }
};

export class AppDateAdapter extends NativeDateAdapter {
  parse(value: any): Date | null {
    if (typeof value === 'string') {
      const trimmed = value.trim();
      const parts = trimmed.split(/[/.\-\s]+/);
      if (parts.length === 3) {
        if (parts[0].length === 4) {
          const year = Number(parts[0]);
          const month = Number(parts[1]) - 1;
          const date = Number(parts[2]);
          const d = new Date(year, month, date);
          if (!isNaN(d.getTime())) return d;
        } else {
          const year = Number(parts[2]);
          const month = Number(parts[1]) - 1;
          const date = Number(parts[0]);
          const d = new Date(year, month, date);
          if (!isNaN(d.getTime())) return d;
        }
      }
    }
    const timestamp = typeof value === 'number' ? value : Date.parse(value);
    return isNaN(timestamp) ? null : new Date(timestamp);
  }

  format(date: Date, displayFormat: Object): string {
    if (displayFormat === 'input' || displayFormat === 'DD/MM/YYYY') {
      let day: string = date.getDate().toString();
      day = +day < 10 ? '0' + day : day;
      let month: string = (date.getMonth() + 1).toString();
      month = +month < 10 ? '0' + month : month;
      let year = date.getFullYear();
      return `${day}/${month}/${year}`;
    }
    return date.toDateString();
  }
}

@NgModule({
  declarations: [
    AccordionAnchorDirective,
    AccordionLinkDirective,
    AccordionDirective,
    DebounceClickDirective,
    ReservationComponent,
    ReservationmodalComponent,
    TableConfigComponent,
    UserNamePipe,
  ],
  imports: [
    // AccordionAnchorDirective,
    // AccordionLinkDirective,
    // AccordionDirective,
    // DebounceClickDirective,
    MatButtonModule,
    MatRadioModule,
    MatInputModule,
    MatMenuModule,
    MatCheckboxModule, MatSliderModule,
    MatButtonModule,
    MatCardModule,
    MatFormFieldModule,
    MatIconModule,
    MatInputModule,
    MatSidenavModule,
    MatListModule,
    MatToolbarModule,
    MatDividerModule,
    MatTableModule,
    MatPaginatorModule,
    MatSortModule,
    MatDialogModule,
    MatSelectModule,
    MatProgressSpinnerModule,
    MatAutocompleteModule,
    MatCheckboxModule,
    MatSlideToggleModule,
    MatMenuModule,
    MatBadgeModule,
    MatExpansionModule,
    MatTabsModule,
    MatTreeModule,
    MatChipsModule,
    MatButtonToggleModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatSnackBarModule,
    ReactiveFormsModule,
    CommonModule,
    FormsModule,
    MatGridListModule,
    MatFabMenuModule,
    EcoFabSpeedDialModule,
    MatTooltipModule,
    NgxMatSelectSearchModule,
    TranslateModule,
    FlexLayoutModule,
    SatPopoverModule,
    // ConnectionServiceModule
  ],
  exports: [
    AccordionAnchorDirective,
    AccordionLinkDirective,
    AccordionDirective,
    DebounceClickDirective,
    MatButtonModule,
    MatRadioModule,
    MatInputModule,
    MatMenuModule,
    MatCheckboxModule, MatSliderModule,
    MatButtonModule,
    MatCardModule,
    MatFormFieldModule,
    MatIconModule,
    MatInputModule,
    MatSidenavModule,
    MatListModule,
    MatToolbarModule,
    MatDividerModule,
    MatTableModule,
    MatPaginatorModule,
    MatSortModule,
    MatDialogModule,
    MatSelectModule,
    MatProgressSpinnerModule,
    MatAutocompleteModule,
    MatCheckboxModule,
    MatSlideToggleModule,
    MatMenuModule,
    MatBadgeModule,
    MatExpansionModule,
    MatTabsModule,
    MatTreeModule,
    MatChipsModule,
    MatButtonToggleModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatSnackBarModule,
    ReactiveFormsModule,
    CommonModule,
    FormsModule,
    MatGridListModule,
    MatFabMenuModule,
    EcoFabSpeedDialModule,
    MatTooltipModule,
    NgxMatSelectSearchModule,
    TranslateModule,
    ReservationComponent,
    ReservationmodalComponent,
    TableConfigComponent,
    SatPopoverModule,
    UserNamePipe,
    // ConnectionServiceModule
    // ReservationComponent
    // FontAwesomeModule
    // FlexLayoutModule

  ],
  providers: [
    MenuItems,
    MenuItemsGuichet,
    AuthGuard,
    RoleGuard,
    SessionGuard,
    MenuItemsRetrait,
    MenuItemsEnvoi,
    MenuItemsChef,
    MenuItemsAccounting,
    MenuItemsFiscalite,
    MenuItemsChefCourrier,
    MenuItemsDispatching,
    { provide: DateAdapter, useClass: AppDateAdapter },
    { provide: MAT_DATE_FORMATS, useValue: APP_DATE_FORMATS }
  ]
})
export class SharedModule { }